import React from "react";
import { Tag, Tooltip } from "antd";
import { 
    ULD_AVAILABILITY_NAMES, 
    ULD_AVAILABILITY_COLORS 
} from "../constants/uldConstantsV3";

/**
 * ULD可用性标签组件（V3模型）
 * 显示ULD的业务可用性
 *
 * @param {Object} props 组件属性
 * @param {string} props.availability ULD可用性代码
 * @param {string} [props.description] 可选的可用性描述信息
 * @param {Object} [props.style] 自定义样式
 */
const UldAvailabilityTag = ({ availability, description, style }) => {
    // 获取可用性名称和颜色
    const availabilityName = ULD_AVAILABILITY_NAMES[availability] || availability;
    const color = ULD_AVAILABILITY_COLORS[availability] || "#999";

    // 带描述的Tag用Tooltip包装
    if (description) {
        return (
            <Tooltip title={description}>
                <Tag color={color} style={{ cursor: "pointer", ...style }}>
                    {availabilityName}
                </Tag>
            </Tooltip>
        );
    }

    // 无描述的简单Tag
    return (
        <Tag color={color} style={style}>
            {availabilityName}
        </Tag>
    );
};

export default UldAvailabilityTag; 